export function parseBoolean(val) {
  try {
    return JSON.parse(val);
  } catch {
    return null;
  }
}

export const removeDashBracket = (str) => {
  if (typeof str !== 'string') return str;
  return str.replace(/[-()\s]+/g, ' ').trim();
};

export function safeParseJSON(jsonString, fallbackValue = false) {
  if (typeof jsonString !== 'string' || jsonString.trim() === '') {
    return fallbackValue;
  }
  try {
    const parsed = JSON.parse(jsonString);
    return parsed === null ? fallbackValue : parsed;
  } catch {
    return fallbackValue;
  }
}
